'use strict';

const SELECTOR = '.donation-panel';

export default function () {
    document.querySelectorAll(SELECTOR).forEach(element => {
        const otherAmountBtn = element.querySelector('#other');
        if (otherAmountBtn) {
            otherAmountBtn.addEventListener('click', () => {
                element.querySelector('.donation-panel__specific-amount').classList.add('hidden');
                element.querySelector('.donation-panel__other-amount').classList.remove('hidden');

                element.querySelectorAll('[type="radio"]').forEach(radio => {
                    radio.required = false;
                });

                element.querySelector('[type="number"]').required = true;
            });
        }

        element.addEventListener('submit', event => {
            event.preventDefault();

            const amountField = element.querySelector('.donation-panel__specific-amount:not(.hidden) input:checked, .donation-panel__other-amount:not(.hidden) input');

            if (!amountField) {
                return alert('Please select/specify a donation amount');
            }

            const amount = parseInt(amountField.value, 10);

            if (!amount) {
                return alert('Please select/specify a valid donation amount');
            }

            window.location.href = decodeURI(event.target.action).replace('{amount}', amount);
        });
    });
}
